<div class="main-view" [class.no-header]="!showAppHeader">
  <div class="visualization-and-legend-view">
    <app-visualization-view-main class="visualization" [active]="nav.activeVisualization"></app-visualization-view-main>
    <app-legend-view-main class="legend" #nav></app-legend-view-main>
  </div>
</div>
